import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: inherit;
	padding-left: var(--spacing-xxx-large);
`;

export const StyledAccountNameWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-medium);
`;
